import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CUSTOM_ICONS } from '@core/icons/custom-icons';

import { IconDefinition } from '../icons/icon-definition.model';

@Injectable({ providedIn: 'root' })
export class IconRegistryService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  constructor() {
    this.register(CUSTOM_ICONS);
  }

  /** Bulk-register an array of icon definitions. */
  register(icons: IconDefinition[]): void {
    for (const icon of icons) {
      this.registerOne(icon);
    }
  }

  /** Register a single icon by inline literal or URL. */
  registerOne(icon: IconDefinition): void {
    try {
      if (icon.literal) {
        const safe = this.sanitizer.bypassSecurityTrustHtml(icon.literal);
        if (icon.namespace) {
          this.iconRegistry.addSvgIconLiteralInNamespace(
            icon.namespace,
            icon.name,
            safe
          );
        } else {
          this.iconRegistry.addSvgIconLiteral(icon.name, safe);
        }
        return;
      }

      if (icon.url) {
        const safe = this.sanitizer.bypassSecurityTrustResourceUrl(icon.url);
        if (icon.namespace) {
          this.iconRegistry.addSvgIconInNamespace(
            icon.namespace,
            icon.name,
            safe
          );
        } else {
          this.iconRegistry.addSvgIcon(icon.name, safe);
        }
        return;
      }

      console.warn(
        `[IconRegistry] "${icon.namespace ? icon.namespace + ':' : ''}${icon.name}" has neither "literal" nor "url" — skipped.`
      );
    } catch (err) {
      console.error(
        `[IconRegistry] Failed to register "${icon.namespace ? icon.namespace + ':' : ''}${icon.name}"`,
        err
      );
    }
  }
}
